import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforeTransferListingCreatedEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public price: number,
  ) {
    super();
  }
}